var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWebhooks2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 25 24",
    width: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.365 5.793a1.199 1.199 0 012.083.014l3.183 5.69a5.993 5.993 0 11-.917 11.079l-.241-.129 1.171-2.09a3.596 3.596 0 10.15-6.35l-.185.1-.02-.034-.964.539-4.268-7.635a1.198 1.198 0 01.008-1.184zm-8.922 6.875l1.581 1.801a3.595 3.595 0 105.956 2.979l.01-.216.018-.001.001-1.25h8.386a1.198 1.198 0 110 2.397h-6.13A5.992 5.992 0 112.243 12.85zM12.403.4a5.993 5.993 0 015.987 5.732l.005.26h-2.397a3.596 3.596 0 10-5.537 3.027l.104.062 1.148.64-4.256 7.641h-.001l-.008.016c-.307.533-.961.74-1.512.502l-.125-.063a1.198 1.198 0 01-.439-1.637l-.009.016 3.145-5.649A5.993 5.993 0 0112.403.4z",
    fill: "#fff"
  })));
}

export default SvgWebhooks2;